export default __webpack_public_path__ + "img/journal-webfont.svg";